export function getPathParams(path: string): string[] {
  const urlArray = path.split('/');
  const params = urlArray.filter(param => param.search(/^:.*/) !== -1);
  return params.map(param => {
    return param.replace(/:/, '');
  });
}

export function replacePathParams(path: string, params: any) {
  getPathParams(path).forEach(
    param => (path = path.replace(`:${param}`, params[param])),
  );
  return path;
}
